import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/home/Home';
import Menu from './components/home/Menu';
import TruckLocator from './components/home/TruckLocator';
import Events from './components/home/Events';
import EventDetails from './components/home/EventDetails';
import News from './components/home/News';
import NewsDetail from './components/home/NewsDetail';
import Contact from './components/home/Contact';
import AboutUs from './components/home/AboutUs';
import Subscription from './components/home/Subscription';
import FoodTrucks from './components/home/FoodTrucks';
import AdminMenu from './components/admin/AdminMenu';


function App() {
  return (
    <>
      <Router>
        <div className="App">
          <Header/>
          {/* <SearchBar/> */}
          <Routes>
            <Route path="/" exact element={<Home />} />
            <Route path="/home" exact element={<Home />} />
            <Route path="/menu" exact element={<Menu />} />
            <Route path="/trucklocator" exact element={<TruckLocator />} />
            <Route path="/events" exact element={<Events />} />
            <Route path="/eventdetails" exact element={<EventDetails />} />
            <Route path="/news" exact element={<News />} />
            <Route path="/newsdetail" exact element={<NewsDetail />} />
            <Route path="/contact" exact element={<Contact />} />
            <Route path="/aboutus" exact element={<AboutUs />} />
            <Route path="/subscription" exact element={<Subscription />} />
            <Route path="/foodtrucks" exact element={<FoodTrucks />} />
            <Route path="/admin/menu" exact element={<AdminMenu />} />
          </Routes> 
          <Footer/>
        </div>
      </Router>
    </>
  )
}

            
export default App;
